/*
 * @Description: '产品中心'页面所有路由
 * @Author: 任录
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2019-07-26 16:48:59
*/

export default [
    {
        path: 'product',
        component: resolve => require(['@/views/product'], resolve),
        name: 'Product',
        meta: {
            nav: '产品中心'
        }
    },
    // {
    //     path: 'product/:id',
    //     component: resolve => require(['@/views/product/detail'], resolve),
    //     name: 'Product_Detail',
    //     meta: {
    //         nav: '产品中心'
    //     }
    // },
    {
      path: 'product/detailOne',
      component: resolve => require(['@/views/product/detailOne'], resolve),
      name: 'Product_Detail1',
      meta: {
        nav: '销项管理'
      }
    },
  {
    path: 'product/detailTwo',
    component: resolve => require(['@/views/product/detailTwo'], resolve),
    name: 'Product_Detail2',
    meta: {
      nav: '销项管理'
    }
  },
  {
    path: 'product/detailThree',
    component: resolve => require(['@/views/product/detailThree'], resolve),
    name: 'Product_Detail3',
    meta: {
      nav: '报销管理'
    }
  },
  {
    path: 'product/detailFour',
    component: resolve => require(['@/views/product/detailFour'], resolve),
    name: 'Product_Detail4',
    meta: {
      nav: 'ocr识别'
    }
  },
  {
    path: 'product/detailFive',
    component: resolve => require(['@/views/product/detailFive'], resolve),
    name: 'Product_Detail5',
    meta: {
      nav: '发票查验查重'
    }
  },
  {
    path: 'product/detailSix',
    component: resolve => require(['@/views/product/detailSix'], resolve),
    name: 'Product_Detail6',
    meta: {
      nav: '施工企业税务管理平台'
    }
  },
  {
    path: 'product/detailTen',
    component: resolve => require(['@/views/product/detailTen'], resolve),
    name: 'Product_Detail10',
    meta: {
      nav: '电子档案管理'
    }
  },
      
]



// WEBPACK FOOTER //
// ./src/router/product.js